<template>
  <el-dialog
    class="dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    :show-close="false"
  >
    <p class="content">{{ dialogInfo.content }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button class="left-button" type="primary" @click="restart">{{
        dialogInfo.leftText
      }}</el-button>
      <el-button class="right-button" type="primary" @click="coninute">{{
        dialogInfo.rightText
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {},
  methods: {
    restart() {
      this.$emit("restart");
    },
    coninute() {
      this.$emit("coninute");
    },
  },
};
</script>

<style lang='scss' scoped>
.dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
}
.content {
  font-weight: bold;
  color: #2e2e2e;
  font-size: 0.1375rem;
  line-height: 0.25rem;
  // text-align: justify;
}
.left-button {
  padding: 0 0.25rem !important;
  margin: 0 0.1875rem;
  // width: 0.925rem;
  height: 0.2875rem;
  border-radius: 0.14375rem;
  // border: none;
  background-color: #ffffff !important;
  color: #5867fe;
  &:hover {
    color: #5867fe !important;
    background-color: #eef0fe !important;
  }
}
.right-button {
  // width: 0.925rem;
  padding: 0 0.25rem !important;
  height: 0.2875rem;
  border-radius: 0.14375rem;
  border: none;
  background-color: #5867fe !important;
}
/deep/ .el-button {
  padding: 0px;
}
// .button {
//   width: 150px;
//   margin-bottom: 20px;
//   border-radius: 24px;
// }
/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .el-dialog__body {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
/deep/ .el-dialog__footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/common/abiltyBeginDialog.vue